import React from 'react';
import { FaTimes } from 'react-icons/fa';
import Select from '../subcomponents/Select';
import { toast } from 'react-toastify';
import currentDomain from '../../Utils/Utils';
const CheckinConfirmationModal = ({ isOpen, title, defaultValues: regValues, onConfirm, onGoBack }) => {

  const [display, setDisplay] = React.useState(false);
  const [vClass, setVClass] = React.useState([{}]);
  const [vehicles, setVehicles] = React.useState(regValues || []);
  // Vehicle waiting on a "Square or Cash?" answer before being marked paid
  const [paymentPrompt, setPaymentPrompt] = React.useState(null);

  // Update vehicles state when regValues changes
  React.useEffect(() => {
    setVehicles(regValues || []);
  }, [regValues]);

  // Check if all vehicles meet the requirements for submission
  const canSubmit = React.useMemo(() => {
    if (!vehicles || vehicles.length === 0) return false;
    
    return vehicles.every(vehicle => 
      vehicle.ispaid && // Must be paid
      vehicle.parking_zone // Must have parking zone assigned
    );
  }, [vehicles]);



  // on load load class
  React.useEffect(() => {

  }, [isOpen]);

  // Check-in happens at the gate on show day, where anything still unpaid is
  // taken on the Square POS kiosk — a separate system that never reaches this
  // app, so there is no payment record to link, only a note.
  const handleMarkPaid = (vehicle, note) => {
    fetch(`${currentDomain(location)}/api/payments/markpaid/${vehicle.car_id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ note }),
    })
      .then((response) => {
        if (response.ok) {
          // Update local state to reflect paid status
          setVehicles(prevVehicles =>
            prevVehicles.map(v =>
              v.car_id === vehicle.car_id
                ? { ...v, ispaid: true, payment_method: 'other', payment_note: note }
                : v
            )
          );
          toast.success('Entry marked as paid.');
        } else {
          throw new Error('Failed to mark entry as paid.');
        }
      })
      .catch(() => {
        toast.error('Error marking entry as paid.');
      });
  }

  const handleCheckIn = (vehicles) => {
    vehicles.forEach(vehicle => {
      fetch(`${currentDomain(location)}/api/entries/markCheckedIn/${vehicle.car_id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      }).then((response) => {
        if (response.ok) {
        } else {
          console.log(response)
          throw new Error();
        }
      }).catch((error) => {
        toast.error('Error Checking in:', error);
      });
    });

  }

  const handleChangeClass = (value, vehicle) => {
    fetch(`${currentDomain(location)}/api/entries/class/${value}/${vehicle.car_id}/update`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      }
    }).then((response) => {
      if (response.ok) {
        setVehicles(prevVehicles => 
          prevVehicles.map(v => 
            v.car_id === vehicle.car_id 
              ? { ...v, class_id: value }
              : v
          )
        );
        toast.success('Entry class updated.');
      } else {
        throw new Error();
      }
    }).catch((error) => {
      toast.error('Error updating entry class:', error);
    });
  }

  const handleChangeParkingZone = (zone_id, vehicle) => {
    const result = fetch(`${currentDomain(location)}/api/parking`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ parkingZone: zone_id, car_uuid: vehicle.car_id }),
    });

    result.then((response) => {
      if (response.ok) {
        // Update local state to reflect parking zone assignment
        setVehicles(prevVehicles => 
          prevVehicles.map(v => 
            v.car_id === vehicle.car_id 
              ? { ...v, parking_zone: zone_id }
              : v
          )
        );
        toast.success('Parking zone updated.');
      } else {
        throw new Error(response.statusText);
      }
    }).catch((error) => {
      toast.error('Error updating parking zone:', error);
    });
  }

  const handleConfirm = () => {
    if (canSubmit) {
      handleCheckIn(vehicles);
      if (onConfirm) {
        onConfirm();
      }
    }
  };

  const handleGoBack = () => {
    if (onGoBack) {
      onGoBack();
    }
  };


  return (
    <>
      {isOpen && (
        <div className="fixed inset-0 flex items-center justify-center z-50">
          {/* Background Overlay */}
          <div className="fixed inset-0 bg-black opacity-50"></div>

          {/* Modal Content */}
          <div className="bg-white p-6 rounded-lg shadow-lg z-10 max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            {/* Modal Header */}
            <div className="mb-6 text-center">
              <h2 className="text-2xl font-bold text-gray-800">
                {title || "Confirm Registration Information"}
              </h2>
              {vehicles && vehicles.length > 0 && !canSubmit && (
                <div className="mt-4 p-3 bg-yellow-50 border border-yellow-200 rounded-lg">
                  <p className="text-sm text-yellow-800 font-medium">
                    Please complete the following before submitting:
                  </p>
                  <ul className="text-sm text-yellow-700 mt-2 space-y-1">
                    {vehicles.map((vehicle, index) => {
                      const issues = [];
                      if (!vehicle.ispaid) issues.push("Payment required");
                      if (!vehicle.parking_zone) issues.push("Parking zone required");
                      
                      if (issues.length > 0) {
                        return (
                          <li key={vehicle.car_id}>
                            Vehicle {index + 1} ({[vehicle.year, vehicle.make, vehicle.model].filter(Boolean).join(' ')}):
                            {issues.map(issue => <span key={issue} className="ml-2">❌ {issue}</span>)}
                          </li>
                        );
                      }
                      return null;
                    }).filter(Boolean)}
                  </ul>
                </div>
              )}
            </div>

            {/* Registration Data Display */}
            {vehicles && vehicles.length > 0 && (
              <div className="space-y-6">
                {/* Personal Information - Display once from first entry */}
                <div className="border-b border-gray-200 pb-4">
                  <h3 className="text-lg font-semibold text-gray-700 mb-3">Personal Information</h3>
                  <div className="grid grid-cols-3 gap-4">
                    <div>
                      <p className="text-sm font-medium text-gray-600">Name</p>
                      <p className="text-gray-800">
                        {`${vehicles[0].owner_first_name || ''} ${vehicles[0].owner_last_name || ''}`.trim() || 'Not provided'}
                      </p>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-gray-600">Email</p>
                      <p className="text-gray-800">{vehicles[0].owner_email || 'Not provided'}</p>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-gray-600">Phone</p>
                      <p className="text-gray-800">{vehicles[0].owner_phone || 'Not provided'}</p>
                    </div>
                  </div>
                </div>

                {/* Vehicle Information - Display each vehicle */}
                <div className="border-b border-gray-200 pb-4">
                  <h3 className="text-lg font-semibold text-gray-700 mb-3">Vehicle Information</h3>
                  <div className="space-y-5">
                    {vehicles.map((vehicle, index) => (
                      <div key={index} className="bg-gray-50 p-4 rounded-lg">
                        <h4 className="font-medium text-gray-700 mb-3">{[vehicle.year, vehicle.make, vehicle.model].filter(Boolean).join(' ') || 'Unknown'}</h4>

                        <div className="grid grid-cols-2 gap-4">
                          {/* Car Number */}
                          <div>
                            <p className="text-sm font-medium text-gray-600">Car Number</p>
                            <p className="text-gray-800">{vehicle.car_number || 'Not assigned'}</p>
                          </div>

                          {/* Paid Status */}
                          <div>
                            <p className="text-sm font-medium text-gray-600">Paid Status</p>
                            <p 
                              className={`font-medium cursor-pointer ${vehicle.ispaid ? 'text-green-600' : 'text-red-600'}`} 
                              onClick={() => {
                                if (!vehicle.ispaid) {
                                  setPaymentPrompt(vehicle);
                                }
                              }}
                            >
                              {vehicle.ispaid ? 'Paid' : 'Unpaid'}
                            </p>
                          </div>
                          {/* Class */}
                          <div>
                            <p className="text-sm font-medium text-gray-600">Class</p>
                            <div className="flex-1 w-2/3 flex justify-between">
                              <Select.SingleVehicleClass
                                onChange={handleChangeClass}
                                value={vehicle.class_id}
                                vehicle={vehicle}
                                disableTitle={true}
                              />
                            </div>
                          </div>

                          {/* Parking Zone */}
                          <div>
                            <p className="text-sm font-medium text-gray-600">Parking Location</p>
                            <div className="flex-1 w-full flex justify-between">
                              <Select.ParkingZones //value, vehicle, onChange, error
                                onChange={handleChangeParkingZone}
                                value={vehicle.parking_zone}
                                vehicle={vehicle}
                              />
                            </div>
                          </div>



                          {/* Engine */}
                          <div>
                            <p className="text-sm font-medium text-gray-600">Engine</p>
                            <p className="text-gray-800">{vehicle.engine || 'Not provided'}</p>
                          </div>

                          {/* Features */}
                          <div>
                            <p className="text-sm font-medium text-gray-600">Features</p>
                            <p className="text-gray-800">{vehicle.features || 'None specified'}</p>
                          </div>

                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}

            {/* Modal Footer */}
            <div className="flex justify-between w-full mt-6 pt-4 border-t border-gray-200">
              {(
                /* New confirmation buttons */
                <>
                  <button
                    onClick={handleGoBack}
                    className="bg-gray-500 text-white px-6 py-2 rounded hover:bg-gray-600 transition-colors"
                  >
                    Go Back
                  </button>
                  <button
                    onClick={handleConfirm}
                    disabled={!canSubmit}
                    className={`px-6 py-2 rounded transition-colors ${
                      canSubmit 
                        ? 'bg-green-500 text-white hover:bg-green-600' 
                        : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                    }`}
                    title={!canSubmit ? 'All vehicles must be paid and have a parking zone assigned' : ''}
                  >
                    Confirm & Submit
                  </button>
                </>
              )}
            </div>
          </div>

          {/* Square / Cash confirmation popup */}
          {paymentPrompt && (
            <div className="fixed inset-0 flex items-center justify-center z-50">
              <div
                className="fixed inset-0 bg-black opacity-50"
                onClick={() => setPaymentPrompt(null)}
              ></div>
              <div className="bg-white p-6 rounded-lg shadow-lg z-10 max-w-md w-full mx-4">
                <h3 className="text-xl font-bold text-gray-800 text-center">
                  How did they pay?
                </h3>
                <p className="text-center text-gray-600 mt-1 mb-6">
                  {[paymentPrompt.year, paymentPrompt.make, paymentPrompt.model].filter(Boolean).join(' ') || 'This vehicle'}
                  {' '}will be marked as paid.
                </p>
                <div className="grid grid-cols-2 gap-4">
                  <button
                    onClick={() => {
                      handleMarkPaid(paymentPrompt, 'Square POS');
                      setPaymentPrompt(null);
                    }}
                    className="bg-blue-600 text-white text-xl font-semibold py-8 rounded-lg hover:bg-blue-700 active:bg-blue-800 transition-colors"
                  >
                    Square
                  </button>
                  <button
                    onClick={() => {
                      handleMarkPaid(paymentPrompt, 'Cash');
                      setPaymentPrompt(null);
                    }}
                    className="bg-green-600 text-white text-xl font-semibold py-8 rounded-lg hover:bg-green-700 active:bg-green-800 transition-colors"
                  >
                    Cash
                  </button>
                </div>
                <button
                  onClick={() => setPaymentPrompt(null)}
                  className="w-full mt-4 py-3 text-gray-600 font-medium rounded-lg hover:bg-gray-100 transition-colors"
                >
                  Cancel
                </button>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};

{/*[
    {
        "car_number": 91,
        "year": 1978,
        "make": "Ford",
        "model": "Bronco",
        "class_name": "Vintage 4x4",
        "owner_first_name": "Richard",
        "owner_last_name": "Kiggins",
        "engine": "400 Ford",
        "club": null,
        "ispaid": true,
        "vtype": 2,
        "features": "Ranger XLT, Free Wheelin package",
        "owner_email": "blumach1@yahoo.com",
        "owner_phone": "2084069429",
        "class_id": "7f362b81-5aab-4dee-9a4f-6a19106edcc3",
        "owner_id": "09909742-4e74-496f-a61a-e640002f9440",
        "car_id": "7d6edf5f-68df-47ad-b4fe-8815bb20c102",
        "class_priority": 15,
        "parking_zone": null
    },
    {
        "car_number": 142,
        "year": 1969,
        "make": "Ford",
        "model": "Mustang",
        "class_name": "C6",
        "owner_first_name": "Richard",
        "owner_last_name": "Kiggins",
        "engine": "390 FE",
        "club": null,
        "ispaid": true,
        "vtype": 1,
        "features": "mach 1",
        "owner_email": "blumach1@yahoo.com",
        "owner_phone": "2084069429",
        "class_id": "99c269e9-3597-4fc5-9943-30b58d37a0d6",
        "owner_id": "09909742-4e74-496f-a61a-e640002f9440",
        "car_id": "eb309edf-5523-4b9b-92b7-d3d3860fdbfe",
        "class_priority": 6,
        "parking_zone": null
    }
]]*/}


export default CheckinConfirmationModal;
